import { render, staticRenderFns } from "./SummaryStorefrontTables.vue?vue&type=template&id=23ea0f5b&scoped=true&"
import script from "./SummaryStorefrontTables.vue?vue&type=script&lang=js&"
export * from "./SummaryStorefrontTables.vue?vue&type=script&lang=js&"
import style0 from "./SummaryStorefrontTables.vue?vue&type=style&index=0&id=23ea0f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea0f5b",
  null
  
)

export default component.exports